<app-lecture-lessons-nav [lecture]="lectureObservable | async" [lessons]="lessonsObservable | async"></app-lecture-lessons-nav>
<!--<app-article-container>-->
  <router-outlet></router-outlet>
<!--</app-article-container>-->



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-lessons/lecture-lessons.component.html